import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import type { DetailsSourceRequest, DetailsSourceResponse } from '../types';
import * as service from '../services';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';

export const useOmnichannelSources = () => {
  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);
  const omnichannelSourcesBodyRequest = useOmnichannelStore(state => state.omnichannelSourcesBodyRequest);
  const getOmnichannelSourcesRequest = async (data: DetailsSourceRequest) => {
    const resp = await service.getOmnichannelDetailsSource(data);
    return resp;
  };

  const successAction = (data: AxiosResponse<DetailsSourceResponse>) => {
    setOmnichannelState('omnichannelSourcesData', data.data);
  };

  const mutate = useMutation({
    mutationFn: getOmnichannelSourcesRequest,
    onSuccess: data => successAction(data),
  });

  const handleOmnichannelSourcesPageChange = (page: number) => {
    const bodyRequest = { ...omnichannelSourcesBodyRequest, page };
    return mutate.mutate(bodyRequest);
  };

  return {
    isLoadingSources: mutate.isPending,
    handleGetOmnichannelSources: mutate.mutate,
    handleOmnichannelSourcesPageChange,
  };
};
